import { Routes, Route } from "react-router-dom";
import MainContainer from "./layout/MainContainer";
import Pages from "./pages";
import Features from "./features";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/sign-up" element={<Pages.Signup />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/signup-form" element={<Pages.SignupForm />} />
      <Route path="/otp" element={<Pages.OtpVerification />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route element={<MainContainer />}>
        <Route path="/dashboard" element={<Pages.Dashboard />} />
        <Route
          path="/manage-notifications"
          element={<Pages.ManageNotifications />}
        />
        <Route
          path="/manage-notifications/add"
          element={<Pages.AddNotification />}
        />
        <Route
          path="/manage-notifications/detail"
          element={<Pages.NotificationDetail />}
        />
        <Route
          path="/recieved-notifications"
          element={<Pages.RecievedNotifications />}
        />
        <Route path="/manage-profile" element={<Pages.ManageProfile />} />
        <Route path="/manage-profile/edit" element={<Pages.EditProfile />} />
        <Route
          path="/manage-profile/change-password"
          element={<Pages.ChangePassword />}
        />
        <Route path="/manage-stores" element={<Pages.ManageStores />} />
        <Route path="/manage-stores/add" element={<Pages.AddStore />} />
        <Route path="/manage-stores/detail" element={<Pages.StoreDetail />} />
        <Route
          path="/manage-transactions"
          element={<Pages.ManageTransction />}
        />
        <Route
          path="/manage-transactions/view"
          element={<Pages.ViewTransction />}
        />
        <Route path="/service-listing" element={<Pages.ServiceListing />} />
        <Route path="/service-listing/add" element={<Pages.AddService />} />
        <Route
          path="/service-listing/edit/:id"
          element={<Pages.AddService />}
        />
        <Route
          path="/service-listing/view/:id"
          element={<Pages.ViewService />}
        />
        <Route path="/portfolio" element={<Pages.Portfolio />} />
        <Route path="/portfolio/add" element={<Pages.AddPortfolio />} />
        <Route path="/portfolio/edit/:id" element={<Pages.AddPortfolio />} />
        <Route path="/portfolio/view/:id" element={<Pages.ViewPortfolio />} />
        <Route path="/chat" element={<Pages.Chat />} />
        <Route path="/earnings" element={<Pages.Earnings />} />
        <Route path="/customer-support" element={<Pages.CustomerSupport />} />
        <Route
          path="/admin-support/view"
          element={<Pages.ViewAdminSupport />}
        />
        <Route path="/bookings" element={<Pages.Bookings />} />
        <Route
          path="/order-management"
          element={<Features.OrderManagement />}
        />
        <Route
          path="/order-management/view/:id"
          element={<Features.ViewOrderManagement />}
        />
        <Route path="/discount-coupon" element={<Features.DiscountCoupon />} />
        <Route path="/discount-coupon/add" element={<Features.AddProduct />} />
        <Route
          path="/discount-coupon/edit/:id"
          element={<Features.AddProduct />}
        />
        <Route
          path="/discount-coupon/view/:id"
          element={<Features.viewDiscount />}
        />
        <Route path="/admin-support" element={<Pages.AdminSupport />} />
        <Route
          path="/admin-support/knowledge-base"
          element={<Pages.KnowledgeBase />}
        />
        <Route
          path="/admin-support/video-tutorial"
          element={<Pages.VideoTutorials />}
        />
        <Route path="/ratings" element={<Pages.Ratings />} />
      </Route>
    </Routes>
  );
};

export default Routing;
